import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProjectProvider } from "@/context/ProjectContext";
import { BrandingProvider } from "@/context/BrandingContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import TenantLogin from "@/pages/TenantLogin";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Control from "@/pages/Control";
import Sensors from "@/pages/Sensors";
import Water from "@/pages/Water";
import Energy from "@/pages/Energy";
import Projects from "@/pages/Projects";
import Users from "@/pages/Users";
import Account from "@/pages/Account";
import Arduino from "@/pages/Arduino";
import Sheets from "@/pages/Sheets";
import Wizard from "@/pages/Wizard";
import Firmware from "@/pages/Firmware";
import Branding from "@/pages/Branding";

function ProtectedShell({ children, adminOnly = false, projectAdminOk = false }) {
  return (
    <ProtectedRoute adminOnly={adminOnly} projectAdminOk={projectAdminOk}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ProjectProvider>
          <BrandingProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/login/p/:projectId" element={<TenantLogin />} />
                <Route path="/register" element={<Register />} />

                <Route path="/" element={<ProtectedShell><Dashboard /></ProtectedShell>} />
                <Route path="/control" element={<ProtectedShell><Control /></ProtectedShell>} />
                <Route path="/sensors" element={<ProtectedShell><Sensors /></ProtectedShell>} />
                <Route path="/water" element={<ProtectedShell><Water /></ProtectedShell>} />
                <Route path="/energy" element={<ProtectedShell><Energy /></ProtectedShell>} />

                <Route path="/projects" element={<ProtectedShell adminOnly><Projects /></ProtectedShell>} />
                <Route path="/users" element={<ProtectedShell adminOnly><Users /></ProtectedShell>} />
                <Route path="/account" element={<ProtectedShell adminOnly><Account /></ProtectedShell>} />
                <Route path="/branding" element={<ProtectedShell adminOnly><Branding /></ProtectedShell>} />
                <Route path="/arduino" element={<ProtectedShell adminOnly projectAdminOk><Arduino /></ProtectedShell>} />
                <Route path="/sheets" element={<ProtectedShell adminOnly projectAdminOk><Sheets /></ProtectedShell>} />
                <Route path="/wizard" element={<ProtectedShell adminOnly projectAdminOk><Wizard /></ProtectedShell>} />
                <Route path="/firmware" element={<ProtectedShell adminOnly projectAdminOk><Firmware /></ProtectedShell>} />
              </Routes>
              <Toaster position="top-right" richColors closeButton />
            </BrowserRouter>
          </BrandingProvider>
        </ProjectProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
